/**
 * 深教AI (SJAI - Shenzhen Education AI) 统一管理工具
 */

class SJAI {
    // 深教AI相关常量
    static get BRAND() {
        return 'sjairelease';
    }

    static get TENANT() {
        return 't_sjai';
    }

    /**
     * 判断当前品牌是否为深教AI
     * @param {Object} state - Vuex store state
     * @returns {boolean}
     */
    static isSJAI(state) {
        return state.brand?.publishBrand?.brand === this.BRAND;
    }

    /**
     * 判断当前租户是否为深教AI
     * @param {Object} state - Vuex store state
     * @returns {boolean}
     */
    static isSJAITenant(state) {
        return state.brand?.publishBrand?.brandTenant?.tenant === this.TENANT;
    }


    /**
     * 生成深教AI登录成功跳转URL
     * @param {Object} data - 登录数据
     * @returns {string} 跳转URL
     */
    static getSuccessJumpUrl(data) {
        const env = this.getEnvSuffix();
        const brand = data?.brand;
        if(brand === this.BRAND) {
            return 'https://sjai.idt.3ren.cn/schedule/aiManage/course/list';
        }
        return `https://${brand}${env || '.idt'}.3ren.cn/schedule/aiManage/course/list`;
    }

    /**
     * 获取深教AI退出登录URL
     * @returns {Promise<string>} 退出登录URL
     */
    static async getLogoutUrl() {
        try {
            const res = await G_transmit('getAuthorizeUrl', {
                name: 'getAuthorizeUrl',
                message: false,
                queries: { type: 'logout' },
            });
            return res?.data || '';
        } catch (err) {
            console.error(err);
            return '';
        }
    }

    /**
     * 处理深教AI未登录错误 - 跳转到登录页面
     */
    static handleNotLogin() {
        const env = this.getEnvSuffix();
        window.location.href = `https://passport${env}.3ren.cn/login/sz-callback?tenant=${this.TENANT}&memberType=teacher`;
    }

    /**
     * 处理深教AI OAuth 登录流程
     * @param {string} code - 授权码
     * @returns {Promise<Object>} 登录结果数据
     */
    static async handleOauthLogin(code) {
        // 深教ai是跳转过来的, 需要等待500ms，否则会报错, 因为注册时间太短，没带得及同步到数据库
        await this.sleep(500);

        const res = await G_transmit('login', {
            name: 'login',
            data: {
                auth_type: 'oauth',
                username: code,
            },
            message: false,
        });

        return res.data || {};
    }

    // 私有工具方法
    static sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    static getEnvSuffix() {
        const { getEnvSuffix } = require('@/lib/tools');
        return getEnvSuffix();
    }
}

export default SJAI;